module.exports = __webpack_public_path__ + "static/media/bg-home.b947af8d.jpg";